const sit = window.sit || {};

export const BREAKPOINTS = sit.breakpoints || {};

export const ajaxUrl = sit.ajax_url;
